import {BaseAttribute} from "@/pages/AppPages/Events/attribute";

export class DeathEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams);
        this.actNumber = null;
        this.actDate = null;
        this.deathDate = null;
        this.circumstances = null;
        this.executorPosition = null;
        this.supportingDocumentDate = null;
        this.supportingDocumentNumber = null;
        this.wasteDisposalOrganizationName = null;


        if (initObjectParams && initObjectParams['actDate']) {
            this.actDate = initObjectParams['actDate']
        }

        if (initObjectParams && initObjectParams['supportingDocumentDate']) {
            this.supportingDocumentDate = initObjectParams['supportingDocumentDate']
        }

        if (initObjectParams && initObjectParams['deathDate']) {
            this.deathDate = initObjectParams['deathDate']
        }

        if (initObjectParams && initObjectParams['executorPosition']) {
            this.executorPosition = initObjectParams['executorPosition']
        }
    }

    static get modelName() {
        return 'DisposalEvent'
    }

    static get validations() {
        return {
            actNumber: {},
            actDate: {},
            deathDate: {},
            circumstances: {},
            executorPosition: {},
            supportingDocumentDate: {},
            supportingDocumentNumber: {},
            wasteDisposalOrganizationName: {}
        }
    }

    static get validationFieldLabels() {
        return {
            actNumber: 'Акт',
            actDate: 'Дата составления',
            deathDate: 'Дата смерти',
            circumstances: 'Обстоятельства',
            executorPosition: 'Должность исполнителя',
            supportingDocumentDate: 'Дата ветеринарного сопроводительного документа',
            supportingDocumentNumber: 'Номер ветеринарного сопроводительного документа',
            wasteDisposalOrganizationName: 'Наименование организации, осуществляющей уничтожение биологических отходов'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.actNumber = data['actNumber'];
        this.actDate = data['actDate'];
        this.deathDate = data['deathDate'];
        this.circumstances = data['circumstances'];
        this.executorPosition = data['executorPosition'];
        this.supportingDocumentDate = data['supportingDocumentDate'];
        this.supportingDocumentNumber = data['supportingDocumentNumber'];
        this.wasteDisposalOrganizationName = data['wasteDisposalOrganizationName'];
    }

}